"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeSerialize = void 0;
/**
 * Safely serializes an object preventing errors that JSON.stringify might throw.
 *
 * @param obj - object to serialize
 *
 * @internal
 */
function safeSerialize(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (_a) {
        return "";
    }
}
exports.safeSerialize = safeSerialize;
//# sourceMappingURL=safeSerialize.js.map